import { render } from "./AssessmentDataTracking.vue?vue&type=template&id=54b0c314"
import script from "./AssessmentDataTracking.vue?vue&type=script&lang=js"
export * from "./AssessmentDataTracking.vue?vue&type=script&lang=js"

import "./AssessmentDataTracking.vue?vue&type=style&index=0&id=54b0c314&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__